import React from "react";
import { Redirect } from 'react-router-dom';
import CheckoutStep from './../Checkout/CheckoutStep.jsx';
import Deliveries from './../Checkout/Deliveries.jsx';
import Payments from './../Checkout/Payments.jsx';
import { Storage } from './../Core/Storage';
import SumInfo from './../Checkout/SumInfo.jsx';
import { CheckoutProvider } from './../Providers/CheckoutProvider';
import { Routes } from './../Core/Constants';
import { AppStore } from './../Core/AppStore'
import { isApplePayAvailable } from './../Core/PaymentUtils';

export default class Checkout extends React.Component {
	state = {
		payments: [],
		shippings: [],
		pricedOrder: null,
		redirectContinue: false,
		places: {}
	}

	componentDidMount = () => {
		AppStore.emit('Checkout.Header', true);
		var that = this;
		if (window.gtm) {
			window.gtm.loaded = false;
		}
		CheckoutProvider.getDeliveryOptions((data) => {
			var cart = Storage.instance().cart;
			if (!cart.shippingId) {
				cart.shippingId = data.defaultShippingId;
			}
			if (!cart.paymentId) {
				cart.paymentId = this.findEnabledPaymentId(data.defaultPaymentId, data.payments.filter((item) => item.eligible && this.isEnabledForStoreId(cart.storeId,item.id)), cart.shippingId, data.shippings, cart.storeId);
			}
			Storage.instance().cart = cart;
			CheckoutProvider.calculate((data) => {
				that.setState({ pricedOrder: data }, window.gtm.loadCheckoutDelivery(data));
			});
			that.setState({
				payments: data.payments.filter((item) => item.eligible && (item.gateway !== "gopay_ap" || isApplePayAvailable())),
				shippings: data.shippings.filter((item) => item.eligible)
			});
			data.shippings.forEach((shipping) => {
				if (shipping.deliveryPlace == 1) {
					that.loadDeliveryPlaces(shipping.id);
				}
			});
		});
	}


	findEnabledPayment = (shippingId,storeId) => {
		var enabledPayments = [];
		var shipping = this.state.shippings.find((item) => {
			return shippingId == item.id;
		});
		if (shipping)
			enabledPayments = shipping.payments.filter(x => this.isEnabledForStoreId(storeId,x));
		return enabledPayments;
	}

	handleChangeDelivery = (e) => {
		var id = e.target.value;
		if (Storage.instance().cart.shippingid != id) {
			this.changeDelivery(id, null);
		}
	}

	changeDelivery(shippingId, storeId) {
		var cart = Storage.instance().cart;
		cart.shippingId = parseInt(shippingId);
		cart.storeId = storeId;//vynuluji pobočku
		//overim payment
		cart.paymentId = this.findEnabledPaymentId(cart.paymentId, this.state.payments, cart.shippingId, this.state.shippings, cart.storeId);
		this.loadCart(cart);
	}

	isEnabledForStoreId(storeId,paymentId) {
		let online = 10;
		let disabledStoresForCard = []
		if (storeId && disabledStoresForCard.indexOf(storeId) >= 0) {
			if (paymentId == online) {
				return false;
			}
		}
		return true;
	}

	findEnabledPaymentId(defaultPaymentId, enabledPayments, shippingId, enabledShipping,storeId) {
		var paymentIds = enabledShipping.find(o => o.id == shippingId).payments;
		if (defaultPaymentId) {
			var payment = enabledPayments.find(o => o.id == defaultPaymentId && this.isEnabledForStoreId(storeId, o.id));
			if (payment && paymentIds.indexOf(defaultPaymentId) >= 0)
				return defaultPaymentId;
		}
		return paymentIds.find((payId) => {
			var payment = enabledPayments.find(o => o.id == payId && o.eligible && this.isEnabledForStoreId(storeId,o));
			if (payment)
				return payment.id;
		});

	}


	componentDidUpdate() {


	}

	handleChangePayment = (e) => {
		var id = parseInt(e.target.value);
		var cart = Storage.instance().cart;
		cart.paymentId = id;


		this.loadCart(cart);
	}

	handleChangeStore = (shippingid, e) => {
		var id = e.target.value;
		var cart = Storage.instance().cart;
		cart.paymentId = id;
		this.loadCart(cart);
	}

	loadCart = (cart) => {
		var that = this;
		Storage.instance().cart = cart;
		CheckoutProvider.calculate((data) => {

			that.setState({ pricedOrder: data });
		});
	}

	loadDeliveryPlaces(shippingId) {
		CheckoutProvider.loadDeliveryPlaces(shippingId, (data) => {
			var places = this.state.places;
			places["place" + shippingId] = data;
			this.setState({ places: places });
		});
	}

	handleSubmit = (e) => {
		e.preventDefault();
		var cart = Storage.instance().cart;
		if (cart.shippingId && cart.paymentId) {
			var shipping = this.state.shippings.find(sh => sh.id == cart.shippingId)
			if (shipping.deliveryPlace && !cart.storeId) {
				alert("Vyberte prosím pobočku")
				return;
			}
			this.setState({ redirectContinue: true });
		}
	}

	render() {
		var T = window.Texts.checkout;
		if (this.state.redirectContinue) {

			return (<Redirect to={Routes.CheckoutUser} />);
		}
		
		let pricedOrder = this.state.pricedOrder;
		let cart = Storage.instance().cart;
		if (!cart || !cart.cartedProducts || cart.cartedProducts.length==0)
			return (<Redirect to={Routes.Cart} />);
		if (!pricedOrder)
			return <div>{T.loading}</div>;
		return (
			<div className="checkout-page">
				<div className="cover">
					<CheckoutStep step="1" />

					<div className="checkout-inner">

						<div className="page-delivery-payment">
							<div className="headline">
								<h1>{T.titleShippingPayment}</h1>
							</div>
							<div className="prow">
								<div className="pcol delivery-payment span-6">
									<form id="checkout-delivery" method="post">
										<div>
											<Deliveries selectedId={cart.shippingId} storeId={cart.storeId} shippingPlaces={this.state.places} shippings={this.state.shippings} onChange={(e) => this.handleChangeDelivery(e)} onChangePlace={(shippingId, placeId) => this.changeDelivery(shippingId, placeId)} />
											<Payments
												selectedId={cart.paymentId}
												payments={this.state.payments}
												enablePayments={this.findEnabledPayment(cart.shippingId, cart.storeId)}
												onChange={(e) => this.handleChangePayment(e)}
												onSubmit={(e) => this.handleSubmit(e)} />
										</div>
									</form>
								</div>
								<SumInfo pricedOrder={pricedOrder} />

							</div>
						</div>
						{T.tradeTerms ?
							<p className="xo-vraceckaInfo">
								{T.tradeConditions + ' '}
								<a href={Routes.TradeTerms} tagret="_blank">
									<u>{T.tradeTerms}</u>
								</a>
							</p> : null}
					</div>
				</div>
			</div>);
	}
}